import { useState, useEffect, useCallback } from "react";
import { TZDate } from "@date-fns/tz";
import {useSelector} from 'react-redux'

export function useCurrentOrders() {
	const [orders, setOrders] = useState([]);
	const timezone = useSelector(state => state.app.timezone);
	
	const cleanOrders = useCallback(() => {
		const now = TZDate.tz(timezone);
		
		const filtered = orders.filter(order => {
			if (!order.finished_at) return true;
			
			const [h, m] = order.finished_at.split(':').map(Number);
			const finishedAt = new TZDate(
				now.getFullYear(),
				now.getMonth(),
				now.getDate(),
				h, m,
				0,
				timezone
			);
			
			const diffMs = now.getTime() - finishedAt.getTime();
			const diffMinutes = diffMs / 1000 / 60;
			
			return diffMinutes <= 7;
		});
		
		setOrders(filtered);
	}, [orders, timezone]);
	
	useEffect(() => {
		const interval = setInterval(cleanOrders, 10000);
		return () => clearInterval(interval);
	}, [cleanOrders]);
	
	useEffect(() => {
		const handleVisibility = () => {
			if (document.visibilityState === "visible") {
				cleanOrders();
			}
		};
		document.addEventListener("visibilitychange", handleVisibility);
		return () => document.removeEventListener("visibilitychange", handleVisibility);
	}, [cleanOrders]);
	
	const setValue = useCallback((newOrders) => {
		setOrders(newOrders);
	}, []);
	
	return { orders, setValue };
}
